import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SubcategoryState } from '../reducers';

export const selectSubcategoryState = createFeatureSelector<SubcategoryState>('subcategory');

export const selectSubcategoryLoading = createSelector(selectSubcategoryState,(state: SubcategoryState) => state.loading);

export const selectSubcategoryList = createSelector(selectSubcategoryState,(state: SubcategoryState) => state.subcategoryList);

export const selectSubcategoryId = createSelector(selectSubcategoryState,(state: SubcategoryState) => state.subcategoryId);

export const selectSubcategoryError = createSelector(selectSubcategoryState,(state: SubcategoryState) => state.error);

export const selectSubcategory = createSelector(selectSubcategoryState,(state: SubcategoryState) => state.subcategory);
